let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Ndc2")).then(() => parcelRequire('ha22e'));